/* ============================================================
   MODA — behaviour layer for Dawn
   Gilrose Finance model (verified to the cent against the
   official Gilrose Loan Calculator quotes, 12/18/24/36/48).
   ============================================================ */
(function(){
  var RATE   = 0.1995;  // 19.95% p.a.
  var BOOK   = 99;      // booking fee
  var CREDIT = 5.15;    // credit check fee
  var PPSR   = 0;       // PPSR fee
  var WKFEE  = 2.50;    // weekly service fee ($10.00/month = x4)

  var UNIT   = { weekly:'p/wk', fortnightly:'p/fn', monthly:'p/mo' };
  var FLABEL = { weekly:'Weekly', fortnightly:'Fortnightly', monthly:'Monthly' };

  function round2(n){ return Math.round(n*100)/100; }

  // Gilrose monthly payment: amortised (cash + booking + credit check) at 19.95%/12 + $10/mo service fee
  function gMonthly(cash, months){
    var A = cash + BOOK + CREDIT + PPSR;
    var r = RATE/12;
    return A * r / (1 - Math.pow(1+r, -months)) + WKFEE*4;
  }
  // payment for the chosen frequency, plus number of payments over the term
  function perPayment(cash, months, freq){
    var m = gMonthly(cash, months), pay, np;
    if(freq==='fortnightly'){ pay = m*12/26; np = Math.round(months*26/12); }
    else if(freq==='monthly'){ pay = m;      np = months; }
    else { pay = m*12/52; np = Math.round(months*52/12); }
    return { pay: round2(pay), np: np };
  }
  function money(n){ return '$'+Number(n).toLocaleString('en-NZ',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function money0(n){ return '$'+Math.round(n).toLocaleString('en-NZ'); }
  window.MODA = { gMonthly:gMonthly, perPayment:perPayment, money:money, paintCards:paintCards };

  function setText(scope, role, val){ var el = scope.querySelector('[data-role="'+role+'"]'); if(el) el.textContent = val; }
  function row(a,b){ return '<div class="moda-frow"><span>'+a+'</span><b>'+b+'</b></div>'; }

  function paintFull(root){
    var cash = parseFloat(root.getAttribute('data-cash'))||0; if(cash<=0) return;
    var term = parseInt(root.getAttribute('data-term'))||48;
    var freq = root.getAttribute('data-freq')||'weekly';
    var pp = perPayment(cash, term, freq);

    setText(root,'weekly', money(pp.pay));
    setText(root,'unit', UNIT[freq]||'p/wk');
    setText(root,'termnote', term+' months');

    var body = root.querySelector('[data-role="accbody"]');
    if(body){
      body.innerHTML =
        row('Advertised package price', money0(cash)) +
        row(FLABEL[freq]+' payment', money(pp.pay)+' × '+pp.np+' payments') +
        row('Interest rate', '19.95%–24.95% p.a.');
    }
    var s = document.querySelector('.moda-sticky');
    if(s){ setText(s,'weekly', money(pp.pay)); setText(s,'unit', UNIT[freq]||'p/wk'); }
  }

  function paintCard(el){
    var cash = parseFloat(el.getAttribute('data-cash'))||0;
    if(cash>0){ el.textContent = money(perPayment(cash,48,'weekly').pay); }
  }

  function paintCards(){
    document.querySelectorAll('.moda-cardprice[data-cash]').forEach(function(el){
      var cash = parseFloat(el.getAttribute('data-cash'))||0;
      if(cash>0){ el.textContent = '$'+Math.ceil(perPayment(cash,48,'weekly').pay); }
    });
    document.querySelectorAll('.moda-dp[data-cash]').forEach(paintCard);
  }

  function wire(){
    document.querySelectorAll('.moda-finance[data-cash]').forEach(function(root){
      paintFull(root);
      if(root.__wired) return;
      root.__wired = true;

      // ---- variant-aware pricing ----
      var vdataEl = root.querySelector('[data-role="variantdata"]');
      var vwrap = root.querySelector('[data-role="variants"]');
      if(vdataEl && vwrap){
        var variants = [];
        try{ variants = JSON.parse(vdataEl.textContent); }catch(e){}
        if(variants.length){
          var first = variants.filter(function(v){return v.available;})[0] || variants[0];
          var sel = first.options.slice();
          var applyVariant = function(){
            var match = null;
            variants.forEach(function(v){ if(!match && v.options.join('~~') === sel.join('~~')) match = v; });
            vwrap.querySelectorAll('.moda-vbtn').forEach(function(b){
              var oi = parseInt(b.getAttribute('data-oi'));
              b.classList.toggle('on', sel[oi] === b.getAttribute('data-val'));
            });
            if(match){
              root.setAttribute('data-cash', (match.price/100).toString());
              paintFull(root);
              var modal = document.getElementById('moda-apply');
              if(modal){
                if(!modal.getAttribute('data-product-base')) modal.setAttribute('data-product-base', modal.getAttribute('data-product')||'');
                modal.setAttribute('data-product', modal.getAttribute('data-product-base') + ' — ' + sel.join(' · '));
              }
            }
          };
          vwrap.querySelectorAll('.moda-vbtn').forEach(function(b){
            b.addEventListener('click', function(){ sel[parseInt(b.getAttribute('data-oi'))] = b.getAttribute('data-val'); applyVariant(); });
          });
          applyVariant();
        }
      }

      var terms = root.querySelector('[data-role="terms"]');
      if(terms){ terms.addEventListener('click', function(e){ var b=e.target.closest('button'); if(!b)return;
        this.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b)});
        root.setAttribute('data-term', b.getAttribute('data-m')); paintFull(root); }); }
      var freq = root.querySelector('[data-role="freq"]');
      if(freq){ freq.addEventListener('click', function(e){ var b=e.target.closest('button'); if(!b)return;
        this.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b)});
        root.setAttribute('data-freq', b.getAttribute('data-f')); paintFull(root); }); }
    });

    paintCards();

    var applyModal = document.getElementById('moda-apply');
    if(applyModal && !applyModal.__wired){ applyModal.__wired = true;
      if(applyModal.parentNode !== document.body) document.body.appendChild(applyModal);
      var financeRoot = document.querySelector('.moda-finance[data-cash]');
      var financeSummary = function(){
        if(!financeRoot || !window.MODA || !window.MODA.perPayment) return '';
        var cash = parseFloat(financeRoot.getAttribute('data-cash'))||0;
        if(cash <= 0) return '';
        var term = parseInt(financeRoot.getAttribute('data-term'),10)||48;
        var freq = financeRoot.getAttribute('data-freq')||'weekly';
        var pp = window.MODA.perPayment(cash, term, freq);
        var unit = freq==='fortnightly' ? 'p/fn' : (freq==='monthly' ? 'p/mo' : 'p/wk');
        var fl = freq.charAt(0).toUpperCase()+freq.slice(1);
        return term+' months · '+fl+' · '+window.MODA.money(pp.pay)+' '+unit+' (approx.)';
      };
      var setVal = function(f, val){ if(f.value !== val){ f.value = val; f.dispatchEvent(new Event('input',{bubbles:true})); f.dispatchEvent(new Event('change',{bubbles:true})); } };
      var findByLabel = function(re){
        var labels = applyModal.querySelectorAll('label');
        for(var i=0;i<labels.length;i++){
          if(re.test(labels[i].textContent||'')){
            var c = labels[i].closest('div') || labels[i].parentNode;
            var f = c && c.querySelector('textarea, input[type="text"], input:not([type])');
            if(f) return f;
          }
        }
        return null;
      };
      var fillProduct = function(){
        var name = applyModal.getAttribute('data-product') || '';
        var tries = 0;
        (function attempt(){
          var summary = financeSummary();
          var pf = applyModal.querySelector('textarea[name="textarea-2"], input[name="textarea-2"]') || findByLabel(/product/i);
          var ff = findByLabel(/payment plan|selected plan|finance|weekly plan/i);
          if(ff && summary){ setVal(ff, summary); ff.setAttribute('readonly','readonly'); }
          if(pf){
            setVal(pf, name + ((summary && !ff) ? '  |  Plan: ' + summary : ''));
            pf.setAttribute('readonly','readonly');
          }
          if((!pf || (summary && !ff)) && tries++ < 15){ setTimeout(attempt, 150); }
        })();
      };
      var openApply = function(){ applyModal.classList.add('open'); applyModal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; fillProduct(); };
      var closeApply = function(){ applyModal.classList.remove('open'); applyModal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; };
      document.querySelectorAll('[data-moda-apply]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openApply(); }); });
      applyModal.querySelectorAll('[data-moda-close]').forEach(function(x){ x.addEventListener('click', closeApply); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape' && applyModal.classList.contains('open')) closeApply(); });
    }

    var seg = document.querySelector('[data-role="island"]');
    if(seg && !seg.__wired){ seg.__wired = true; seg.addEventListener('click', function(e){ var b=e.target.closest('button'); if(!b)return;
      this.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b)});
      var south = b.getAttribute('data-i')==='south';
      document.querySelectorAll('.moda-reg:not(.wide)').forEach(function(r){
        r.innerHTML = south ? '<i class="moda-ic ti ti-info-circle"></i>North Island only' : '<i class="moda-ic ti ti-map-pin"></i>North Island';
        r.style.color = south ? 'var(--moda-amber-ink)' : '';
        r.style.background = south ? 'var(--moda-amber-soft)' : '';
        r.style.borderColor = south ? '#ead9b4' : '';
      });
    }); }

    var sticky = document.querySelector('.moda-sticky');
    if(sticky && !sticky.__wired){ sticky.__wired = true; window.addEventListener('scroll', function(){ sticky.classList.toggle('show', window.scrollY>480); }, {passive:true}); }
  }

  // Accordion: delegated so it works even after section reloads
  document.addEventListener('click', function(e){
    var h = e.target.closest('.moda-acc-h');
    if(h){ var acc = h.closest('.moda-acc'); if(acc) acc.classList.toggle('open'); }
  });
  window.MODA.wire = wire;

  if(document.readyState!=='loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);
})();


/* ===== Interactive inits — re-runnable for Shopify section (re)loads ===== */
function modaInitInteractive(scope){
  scope = scope || document;
  scope.querySelectorAll('.moda-cat').forEach(function(card){
    if(card.__modaGlow) return; card.__modaGlow = true;
    card.addEventListener('mousemove', function(e){
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });
  scope.querySelectorAll('[data-moda-cban]').forEach(function(b){
    if(b.__modaCban) return; b.__modaCban = true;
    var layer = b.querySelector('[data-parallax]');
    b.addEventListener('mousemove', function(e){
      var r = b.getBoundingClientRect();
      b.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      b.style.setProperty('--my', (e.clientY - r.top) + 'px');
      b.setAttribute('data-hover','1');
      if(layer){ var px=(e.clientX-r.left)/r.width-0.5, py=(e.clientY-r.top)/r.height-0.5; layer.style.transform='translate('+(px*22)+'px,'+(py*18)+'px)'; }
    });
    b.addEventListener('mouseleave', function(){ b.setAttribute('data-hover','0'); if(layer) layer.style.transform=''; });
  });
  scope.querySelectorAll('.moda-caro').forEach(function(c){
    if(c.__modaCaro) return; c.__modaCaro = true;
    var track = c.querySelector('[data-caro-track]'); if(!track) return;
    var amt = function(){ return Math.max(260, track.clientWidth * 0.85); };
    var p = c.querySelector('[data-caro-prev]'), n = c.querySelector('[data-caro-next]');
    if(p) p.addEventListener('click', function(){ track.scrollBy({left:-amt(), behavior:'smooth'}); });
    if(n) n.addEventListener('click', function(){ track.scrollBy({left:amt(), behavior:'smooth'}); });
  });
}

if(document.readyState!=='loading') modaInitInteractive(document);
else document.addEventListener('DOMContentLoaded', function(){ modaInitInteractive(document); });

/* Repaint prices + re-init when the theme editor (or a lazy section) (re)loads a section */
document.addEventListener('shopify:section:load', function(e){
  if(window.MODA && window.MODA.paintCards) window.MODA.paintCards();
  if(window.MODA && window.MODA.wire) window.MODA.wire();
  modaInitInteractive(e.target || document);
});